subscription GenerateIntegrationStatusSub($integrationDocumentId: UUID!) {
  generateIntegrationStatus(integrationDocumentId: $integrationDocumentId) {
    status
    integrationDocument
    {
      entityId
    }
  }
}
